import { del, get, post, put } from "./api_helper"

// branches
const getWorkClass = () => get("admin/attendance/work-classification")
const getToday = () => get(`admin/attendance/today`)
const getMonthHistory = params =>
  get(`admin/attendance/history/${params.year}/${params.month}`)
const getStaffMonthHistory = params =>
  get(
    `admin/attendance/history/${params.year}/${params.month}/${params.staffId}`
  )
const getDateHistory = payload =>
  get(`admin/attendance/history/${payload.date}`)
const getDateHistoryStaff = params =>
  get(`admin/attendance/history/detail/${params.date}/${params.staffId}`)
const getDateAllHistory = date => get(`admin/attendance/history/all/${date}`)
const getAssignmentList = date => get(`admin/attendance/assignment-list`)
const getOtherWork = date => get(`admin/attendance/other-work/list`)
const getOrderList = date => get(`admin/attendance/all-order/list`)
const downloadCSV = ({ year, month }, payload) =>
  get(`admin/attendance/history/${year}/${month}/csv`, payload)

const postClockIn = () => post(`admin/attendance/clock-in`)
const postClockOut = payload => post(`admin/attendance/clock-out`, payload)

const putAttendance = payload =>
  put(`admin/attendance/${payload.attendanceDate}`, payload)
const putAttendanceStaff = payload =>
  put(`admin/attendance/${payload.attendanceDate}/${payload.staffId}`, payload)
const deleteStampDate = params => del(`admin/attendance/${params.date}`)
const deleteStampDateStaff = params =>
  del(`admin/attendance/${params.date}/${params.staffId}`)

const downloadCSVOutWork = ({ year, month }) =>
  get(`admin/attendance/history/all/${year}/${month}/output-work/csv`, "", {
    responseType: "arraybuffer",
  })

const downloadCSVOutWorkByStaff = ({ year, month, staffId }) =>
  get(
    `admin/attendance/history/${year}/${month}/${staffId}/output-work/csv`,
    "",
    { responseType: "arraybuffer" }
  )

const attendanceAPI = {
  getWorkClass,
  getToday,
  getMonthHistory,
  getStaffMonthHistory,
  getDateHistory,
  getDateHistoryStaff,
  getDateAllHistory,
  getAssignmentList,
  getOtherWork,
  getOrderList,
  postClockIn,
  postClockOut,
  putAttendance,
  putAttendanceStaff,
  deleteStampDate,
  deleteStampDateStaff,
  downloadCSV,
  downloadCSVOutWork,
  downloadCSVOutWorkByStaff,
}

export default attendanceAPI
